/* Next Story Bags — COA add-on.
 * When the "Add the LegitApp Certificate of Authenticity" checkbox is ticked,
 * the $25 certificate variant is added to the cart just before the main
 * product's own add-to-cart completes, so both land in the cart (and the cart
 * drawer / checkout) together. One certificate per item (deduped per product):
 * ticking the box on two different bags adds two certificates, each tagged
 * with the bag it belongs to.
 */
(function () {
  if (window.__nsbCoaAddonInit) return;
  window.__nsbCoaAddonInit = true;

  function cartHasCoaForItem(variantId, productTitle) {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        return (cart.items || []).some(function (item) {
          return (
            String(item.variant_id) === String(variantId) &&
            item.properties &&
            String(item.properties['For item']) === String(productTitle)
          );
        });
      })
      .catch(function () { return false; });
  }

  function addCoaToCart(variantId, productTitle) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        properties: {
          'For item': productTitle,
          _nsb_coa_addon: 'true'
        }
      })
    }).then(function (r) { return r.json(); });
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || form.tagName !== 'FORM') return;
      if (!form.matches('form[data-type="add-to-cart-form"]')) return;
      // Second pass after we already added the certificate: let Dawn's handler run.
      if (form.dataset.nsbCoaDone === '1') return;

      var scope = form.closest('.product') || form.closest('[id^="shopify-section-"]') || document;
      var checkbox = scope.querySelector('.nsb-coa-addon__checkbox');
      if (!checkbox || !checkbox.checked) return;

      var variantId = checkbox.getAttribute('data-coa-variant-id');
      if (!variantId) return;

      // Pause the main submit, add the certificate first, then continue.
      event.preventDefault();
      event.stopPropagation();

      var productTitle = checkbox.getAttribute('data-product-title') || '';
      cartHasCoaForItem(variantId, productTitle)
        .then(function (exists) {
          return exists ? null : addCoaToCart(variantId, productTitle);
        })
        .catch(function () {
          return null;
        })
        .then(function () {
          form.dataset.nsbCoaDone = '1';
          if (typeof form.requestSubmit === 'function') {
            form.requestSubmit();
          } else {
            form.submit();
          }
        });
    },
    true
  );
})();
